import Table from "react-bootstrap/Table";
import _ from "lodash";
import * as setOffSelectors from "../../../../selectors/set-off";
import { Form } from "react-bootstrap";
import CustomPriceSpan from "../../../../components/CustomPriceSpan";
import CurrencyInput from "react-currency-input-field";
import clsx from "clsx";
import EmptyItemView from "../../../../components/EmptyItemView";
import React, { useRef, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Helper from "../../../../utils/Helper";
import {getSetOffTotalOutstandingAmountFullText} from "../../../../selectors/set-off";

function SetWithdrawTable({ data = [], partAmt, setPartAmt, debitValue, selectedCurrency,isEspEnabled ,isFetched, isOperateWithdraw, isOperateWithdrawCutOff}) {
  const [checkedItems, setCheckedItems] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const tooltipsRef = useRef();

  const handleCheckboxChange = (index, total) => {
    setCheckedItems((prevCheckedItems) => {
      const newCheckedItems = { ...prevCheckedItems, [index]: !prevCheckedItems[index] };
      const isChecked = newCheckedItems[index];
      setPartAmt((prevPartAmt) => ({
        ...prevPartAmt,
        [index]: {
          total: isChecked ? Math.abs(total) : 0,
          negative: total < 0,
        },
      }));

      return newCheckedItems;
    });
  };

  const handleSelectAllChange = () => {
    const newCheckedItems = {};
    const newPartAmt = {};

    if (!selectAllChecked) {
      _.forEach(data, (setOff, index) => {
        const total = setOffSelectors.getSetOffTotalOutstandingBalance(setOff);
        if (Math.abs(total) !== 0) {
          newCheckedItems[index] = true;
          newPartAmt[index] = {
            total: Math.abs(total),
            negative: total < 0,
          };
        }
      });
    } else {
      _.forEach(data, (setOff, index) => {
        newCheckedItems[index] = false;
        newPartAmt[index] = {
          total: 0,
          negative: false,
        };
      });
    }

    setCheckedItems(newCheckedItems);
    setPartAmt(newPartAmt);
    setSelectAllChecked(!selectAllChecked);
  };

  return (
    <div className={"responsive-table-border mt-4 "}>

      <Table responsive="lg" className="position-relative">
        {!isOperateWithdraw && (
            <div className={"overlayIsOperate"}>
              {/*<div className={"overlayIsOperateText"}>*/}
              {/*  /!*<p>hi</p>*!/*/}
              {/*  Please Try Again Tomorrow. Our Cut off time is {isOperateWithdrawCutOff}.ss*/}
              {/*</div>*/}
            </div>
        )}
        <thead>
        <tr className={"custom-table-setoff-styled"}>
          {/*===== For "CheckBox" ===== */}
          {/*<th style={{ width: "30px" }}>-</th>*/}
          <th style={{width: "30px"}}>
            <Form.Check
                checked={selectAllChecked}
                className="custom-setoff-table-checkbox"
                disabled={!isEspEnabled || !isOperateWithdraw}
                onChange={handleSelectAllChange}
            />
          </th>
          <th style={{width: 100}}>Date</th>
          <th style={{width: 120}}>Reference No</th>
          <th style={{width: 100}}>Stock Code</th>
          <th style={{width: 150}}>Stock Name</th>
          <th style={{width: 100}}>Total Amount</th>
          <th style={{width: 100}}>Balance Amount</th>
          {/*===== End for For "CheckBox" ===== */}
          {/*===== For "Part Amt" ===== */}
          <th style={{width: "200px"}}>Selected Amount</th>
          {/*===== End for "Part Amt" ===== */}
        </tr>
        </thead>
        <tbody>
        {!_.isEmpty(data) ? (
            _.map(data, (setOff, index) => {
              const refNo = setOffSelectors.getSetOffContractReference(setOff);
              const date = setOffSelectors.getSetOffTransactionDate(setOff);
              const stockCode = setOffSelectors.getSetOffStockCode(setOff);
              const stockName = setOffSelectors.getSetOffStockName(setOff);
              const balAmount = setOffSelectors.getSetOffTotalOutstandingBalance(setOff);
              const accrueInterest = setOffSelectors.getSetOffAccrueInterestFullText(setOff);
              const balAmountFullText = setOffSelectors.getSetOffTotalOutstandingBalanceFullText(setOff);
              const total = setOffSelectors.getSetOffTotalOutstandingBalance(setOff);
              const amount = setOffSelectors.getSetOffOutstandingAmountFullText(setOff);
              const totalOutstandingAmount = setOffSelectors.getSetOffTotalOutstandingAmountFullText(setOff);
              return (
                  <tr
                      key={index}
                      className={clsx({
                        ["disabled"]: Math.abs(total) <= 0,
                      })}
                      onClick={(e) => {
                        if (Math.abs(total) <= 0) {
                          tooltipsRef.current?.open({
                            position: {
                              x: e.clientX,
                              y: e.clientY,
                            },
                            place: "bottom",
                            content: "The balance is less than 0.",
                          });
                        }
                      }}
                      onMouseEnter={(e) => {
                        if (Math.abs(total) <= 0) {
                          tooltipsRef.current?.open({
                            position: {
                              x: e.clientX,
                              y: e.clientY,
                            },
                            place: "bottom",
                            content: "The balance is less than 0.",
                          });
                        }
                      }}
                      onMouseLeave={(e) => {
                        tooltipsRef.current?.close();
                      }}
                  >
                    <td style={{width: "30px"}}>
                      <Form.Check
                          checked={checkedItems[index]}
                          className="custom-setoff-table-checkbox"
                          onChange={() => handleCheckboxChange(index, total)}
                      />
                    </td>
                    <td style={{width: 100}}>{date}</td>
                    <td style={{width: 120}}>{refNo}</td>
                    <td style={{width: 100}}>{stockCode ?? '-'}</td>
                    <td style={{width: 150}}>{stockName ?? '-'}</td>
                    <td style={{width: 100}}>{totalOutstandingAmount}</td>
                    <td style={{width: 100}}>{balAmountFullText}</td>
                    <td>
                      <CurrencyInput
                          id="input-example"
                          name="input-name"
                          disabled={Math.abs(total) <= 0}
                          placeholder="Please enter a number"
                          prefix={Math.floor(total) > 0 ? "+" : "-"}
                          className={clsx("custom-setoff-table-input")}
                          value={_.get(partAmt, [index, "total"], 0)}
                          decimalScale={2}
                          decimalSeparator="."
                          groupSeparator=","
                          max={`${Math.abs(balAmount)}`}
                          min={0}
                          onValueChange={(value, name, values) => {
                            setCheckedItems((prevCheckedItems) => {
                              return {
                                ...prevCheckedItems,
                                [index]: Math.abs(value) !== undefined && Math.abs(value) !== 0
                              };
                            });
                            setPartAmt((prev) => {
                              let newValue = value;

                              if (Math.abs(newValue) > Math.abs(balAmount)) {
                                newValue = Math.abs(balAmount)
                              }

                              if (newValue === undefined) {
                                newValue = "0";
                              }

                              // if (_.last(newValue) === ".") {
                              //   return {
                              //     ...prev,
                              //     [index]: {
                              //       total: `${Math.abs(value)}.`,
                              //       negative: total < 0,
                              //     },
                              //   };
                              // }
                              // if (_.includes(newValue, ".") && _.last(newValue) !== ".") {
                              //   return {
                              //     ...prev,
                              //     [index]: {
                              //       total: _.join(_.drop(newValue), ""),
                              //       negative: total < 0,
                              //     },
                              //   };
                              // }

                              // const abs = _.floor(newValue, 2) * 100;
                              // const finalValue = Math.abs(abs) / 100;
                              if (newValue && newValue.toString().substring(0, 1) === '-') {
                                newValue = newValue.slice(1)
                              }
                              return {
                                ...prev,
                                [index]: {
                                  total: newValue,
                                  negative: total < 0,
                                },
                              };
                            });
                          }}
                      />
                    </td>
                  </tr>
              );
            })
        ) : (
            <tr>
              <td colSpan={8}>
                <EmptyItemView/>
              </td>
            </tr>
        )}
        </tbody>
        <tfoot className="setoff-table-footer">
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>Withdrawal Amount</th>
          <th>
            <div className="d-flex justify-content-between">
                <span>
                  {selectedCurrency?.text} <CustomPriceSpan value={debitValue}></CustomPriceSpan>
                </span>
              </div>
            </th>
          </tr>
        </tfoot>
        {!isEspEnabled && isFetched ? <div className='overlay-bg text-bold-600 h4'>Please apply for ESP to proceed with e-withdrawal</div> :false}
      </Table>

      <ReactTooltip ref={tooltipsRef} className="tooltip-info" variant="info"></ReactTooltip>
    </div>
  );
}

export default SetWithdrawTable;
